/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfGetInternationalGroupPricesDto } from '../models/custom-result-of-get-international-group-prices-dto';
import { CustomResultOfGroupPriceByOrganizationIdDto } from '../models/custom-result-of-group-price-by-organization-id-dto';
import { CustomResultOfGroupPriceDto } from '../models/custom-result-of-group-price-dto';
import { CustomResultOfListOfGetOrganizationGroupPricesDto } from '../models/custom-result-of-list-of-get-organization-group-prices-dto';
import { CustomResultOfListOfGroupPriceListDto } from '../models/custom-result-of-list-of-group-price-list-dto';
import { CustomResultOfPaginatedListOfGroupPriceByCategoryIdWithPaginationDto } from '../models/custom-result-of-paginated-list-of-group-price-by-category-id-with-pagination-dto';
import { groupPricesCreateGet } from '../fn/group-prices/group-prices-create-get';
import { GroupPricesCreateGet$Params } from '../fn/group-prices/group-prices-create-get';
import { groupPricesCreatePost } from '../fn/group-prices/group-prices-create-post';
import { GroupPricesCreatePost$Params } from '../fn/group-prices/group-prices-create-post';
import { groupPricesDelete } from '../fn/group-prices/group-prices-delete';
import { GroupPricesDelete$Params } from '../fn/group-prices/group-prices-delete';
import { groupPricesGetGroupPriceByCategoryId } from '../fn/group-prices/group-prices-get-group-price-by-category-id';
import { GroupPricesGetGroupPriceByCategoryId$Params } from '../fn/group-prices/group-prices-get-group-price-by-category-id';
import { groupPricesGetGroupPriceByOrganizationId } from '../fn/group-prices/group-prices-get-group-price-by-organization-id';
import { GroupPricesGetGroupPriceByOrganizationId$Params } from '../fn/group-prices/group-prices-get-group-price-by-organization-id';
import { groupPricesGetGroupPriceListByCategoryId } from '../fn/group-prices/group-prices-get-group-price-list-by-category-id';
import { GroupPricesGetGroupPriceListByCategoryId$Params } from '../fn/group-prices/group-prices-get-group-price-list-by-category-id';
import { groupPricesGetGroupPricesAudit } from '../fn/group-prices/group-prices-get-group-prices-audit';
import { GroupPricesGetGroupPricesAudit$Params } from '../fn/group-prices/group-prices-get-group-prices-audit';
import { groupPricesGetInternationalGroupPrice } from '../fn/group-prices/group-prices-get-international-group-price';
import { GroupPricesGetInternationalGroupPrice$Params } from '../fn/group-prices/group-prices-get-international-group-price';
import { groupPricesGetOrganizationGroupPrices } from '../fn/group-prices/group-prices-get-organization-group-prices';
import { GroupPricesGetOrganizationGroupPrices$Params } from '../fn/group-prices/group-prices-get-organization-group-prices';
import { groupPricesGetOwnerGroupPrices } from '../fn/group-prices/group-prices-get-owner-group-prices';
import { GroupPricesGetOwnerGroupPrices$Params } from '../fn/group-prices/group-prices-get-owner-group-prices';
import { groupPricesUpdateGet } from '../fn/group-prices/group-prices-update-get';
import { GroupPricesUpdateGet$Params } from '../fn/group-prices/group-prices-update-get';
import { groupPricesUpdatePut } from '../fn/group-prices/group-prices-update-put';
import { GroupPricesUpdatePut$Params } from '../fn/group-prices/group-prices-update-put';

@Injectable({ providedIn: 'root' })
export class GroupPricesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `groupPricesGetOwnerGroupPrices()` */
  static readonly GroupPricesGetOwnerGroupPricesPath = '/GroupPrices/GetOwnerGroupPrices';

  /**
   * Get Owner GroupPrices.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetOwnerGroupPrices()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetOwnerGroupPrices$Response(params: GroupPricesGetOwnerGroupPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGroupPriceByOrganizationIdDto>> {
    return groupPricesGetOwnerGroupPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Owner GroupPrices.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetOwnerGroupPrices$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetOwnerGroupPrices(params: GroupPricesGetOwnerGroupPrices$Params, context?: HttpContext): Observable<CustomResultOfGroupPriceByOrganizationIdDto> {
    return this.groupPricesGetOwnerGroupPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGroupPriceByOrganizationIdDto>): CustomResultOfGroupPriceByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `groupPricesGetInternationalGroupPrice()` */
  static readonly GroupPricesGetInternationalGroupPricePath = '/GroupPrices/GetInternationalGroupPrice';

  /**
   * دریافت تعرفه بین الملل.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetInternationalGroupPrice()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesGetInternationalGroupPrice$Response(params?: GroupPricesGetInternationalGroupPrice$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetInternationalGroupPricesDto>> {
    return groupPricesGetInternationalGroupPrice(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعرفه بین الملل.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetInternationalGroupPrice$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesGetInternationalGroupPrice(params?: GroupPricesGetInternationalGroupPrice$Params, context?: HttpContext): Observable<CustomResultOfGetInternationalGroupPricesDto> {
    return this.groupPricesGetInternationalGroupPrice$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetInternationalGroupPricesDto>): CustomResultOfGetInternationalGroupPricesDto => r.body)
    );
  }

  /** Path part for operation `groupPricesGetGroupPriceByOrganizationId()` */
  static readonly GroupPricesGetGroupPriceByOrganizationIdPath = '/GroupPrices/GetGroupPriceByOrganizationId';

  /**
   * دریافت تعرفه سازمان بر اساس شناسه آن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetGroupPriceByOrganizationId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetGroupPriceByOrganizationId$Response(params: GroupPricesGetGroupPriceByOrganizationId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGroupPriceByOrganizationIdDto>> {
    return groupPricesGetGroupPriceByOrganizationId(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت تعرفه سازمان بر اساس شناسه آن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetGroupPriceByOrganizationId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetGroupPriceByOrganizationId(params: GroupPricesGetGroupPriceByOrganizationId$Params, context?: HttpContext): Observable<CustomResultOfGroupPriceByOrganizationIdDto> {
    return this.groupPricesGetGroupPriceByOrganizationId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGroupPriceByOrganizationIdDto>): CustomResultOfGroupPriceByOrganizationIdDto => r.body)
    );
  }

  /** Path part for operation `groupPricesCreateGet()` */
  static readonly GroupPricesCreateGetPath = '/GroupPrices/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesCreateGet$Response(params?: GroupPricesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return groupPricesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesCreateGet(params?: GroupPricesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.groupPricesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `groupPricesCreatePost()` */
  static readonly GroupPricesCreatePostPath = '/GroupPrices/Create';

  /**
   * Create GroupPrice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesCreatePost$Response(params: GroupPricesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPricesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create GroupPrice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesCreatePost(params: GroupPricesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPricesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPricesUpdateGet()` */
  static readonly GroupPricesUpdateGetPath = '/GroupPrices/Update';

  /**
   * Get GroupPriceDetailById.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesUpdateGet$Response(params?: GroupPricesUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGroupPriceDto>> {
    return groupPricesUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get GroupPriceDetailById.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesUpdateGet(params?: GroupPricesUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGroupPriceDto> {
    return this.groupPricesUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGroupPriceDto>): CustomResultOfGroupPriceDto => r.body)
    );
  }

  /** Path part for operation `groupPricesUpdatePut()` */
  static readonly GroupPricesUpdatePutPath = '/GroupPrices/Update';

  /**
   * Update GroupPrice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesUpdatePut$Response(params: GroupPricesUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPricesUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update GroupPrice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesUpdatePut(params: GroupPricesUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPricesUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPricesDelete()` */
  static readonly GroupPricesDeletePath = '/GroupPrices/Delete';

  /**
   * Delete GroupPrice.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesDelete$Response(params?: GroupPricesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return groupPricesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete GroupPrice.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesDelete(params?: GroupPricesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.groupPricesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `groupPricesGetOrganizationGroupPrices()` */
  static readonly GroupPricesGetOrganizationGroupPricesPath = '/GroupPrices/GetOrganizationGroupPrices';

  /**
   * Get Organization GroupPrices For dropdown.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetOrganizationGroupPrices()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesGetOrganizationGroupPrices$Response(params?: GroupPricesGetOrganizationGroupPrices$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetOrganizationGroupPricesDto>> {
    return groupPricesGetOrganizationGroupPrices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Organization GroupPrices For dropdown.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetOrganizationGroupPrices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesGetOrganizationGroupPrices(params?: GroupPricesGetOrganizationGroupPrices$Params, context?: HttpContext): Observable<CustomResultOfListOfGetOrganizationGroupPricesDto> {
    return this.groupPricesGetOrganizationGroupPrices$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetOrganizationGroupPricesDto>): CustomResultOfListOfGetOrganizationGroupPricesDto => r.body)
    );
  }

  /** Path part for operation `groupPricesGetGroupPricesAudit()` */
  static readonly GroupPricesGetGroupPricesAuditPath = '/GroupPrices/GetGroupPricesAudit';

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetGroupPricesAudit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetGroupPricesAudit$Response(params: GroupPricesGetGroupPricesAudit$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return groupPricesGetGroupPricesAudit(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for super admin, Get all audit logs, startDate and endDate is UTC LocalTime.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetGroupPricesAudit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetGroupPricesAudit(params: GroupPricesGetGroupPricesAudit$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.groupPricesGetGroupPricesAudit$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `groupPricesGetGroupPriceByCategoryId()` */
  static readonly GroupPricesGetGroupPriceByCategoryIdPath = '/GroupPrices/GetGroupPriceByCategoryId';

  /**
   * Get group prices by category with pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetGroupPriceByCategoryId()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetGroupPriceByCategoryId$Response(params: GroupPricesGetGroupPriceByCategoryId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGroupPriceByCategoryIdWithPaginationDto>> {
    return groupPricesGetGroupPriceByCategoryId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group prices by category with pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetGroupPriceByCategoryId$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupPricesGetGroupPriceByCategoryId(params: GroupPricesGetGroupPriceByCategoryId$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGroupPriceByCategoryIdWithPaginationDto> {
    return this.groupPricesGetGroupPriceByCategoryId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGroupPriceByCategoryIdWithPaginationDto>): CustomResultOfPaginatedListOfGroupPriceByCategoryIdWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `groupPricesGetGroupPriceListByCategoryId()` */
  static readonly GroupPricesGetGroupPriceListByCategoryIdPath = '/GroupPrices/GetGroupPriceListByCategoryId';

  /**
   * Get group price list.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupPricesGetGroupPriceListByCategoryId()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesGetGroupPriceListByCategoryId$Response(params?: GroupPricesGetGroupPriceListByCategoryId$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGroupPriceListDto>> {
    return groupPricesGetGroupPriceListByCategoryId(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group price list.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `groupPricesGetGroupPriceListByCategoryId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupPricesGetGroupPriceListByCategoryId(params?: GroupPricesGetGroupPriceListByCategoryId$Params, context?: HttpContext): Observable<CustomResultOfListOfGroupPriceListDto> {
    return this.groupPricesGetGroupPriceListByCategoryId$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGroupPriceListDto>): CustomResultOfListOfGroupPriceListDto => r.body)
    );
  }

}
